import React from "react";
import CardVideoPopUp from "../../../newComponents/cardVideoPopUp";
import GeneralSection from "../../../newComponents/generalSection";
import YoutubeEmbed from "../../../newComponents/youtubeEmbed";

const VideoGroup = ({ blocks, }) => (
  <GeneralSection>
    <div className="boxes swiper-container js-load-more js-slider-boxes-projects mb-4">
      <ul>
        {blocks.map((block, index) => {
          
          if(block.video && block.video.url) {

            const id = block.video.url.substr(block.video.url.length - 11);
            const placeHolderImage = <div style={{position: "relative", width: "100%", height: "0", paddingBottom: "56.25%"}}>
              <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt="" height="100%" width="100%" style={{ position: "absolute", width: "100%", height: "100%", left: "0", top: "0", }}/>
            </div>;

            return (
              <CardVideoPopUp key={`video-group-${block.id}-item-${index}`} image={block.videoThumbnail[0]} title={block.video.title} readMoreLabel="View video" ar={16/9} placeHolderImage={placeHolderImage} modalTitle={block.video.title}>
                <YoutubeEmbed title={block.video.title} url={block.video.url} ar={block.video.aspectRatio}/>
              </CardVideoPopUp>
            );
          } else return <></>
        })}
      </ul>
      <div className="swiper-pagination boxes__pagination" />
    </div>
  </GeneralSection>
);

export default VideoGroup;